import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { ArrowLeft, Calendar, CheckCircle, Clock } from 'lucide-react';
import { getMockSessions } from '../mock';

const Sessions = () => {
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    setSessions(getMockSessions());
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('id-ID', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50 p-4 md:p-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Kembali
          </Button>
        </div>

        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold mb-2 bg-gradient-to-r from-orange-600 via-pink-600 to-purple-600 bg-clip-text text-transparent">
            Riwayat Sesi Undian
          </h1>
          <p className="text-gray-600">Semua sesi undian yang telah dibuat</p>
        </div>

        <div className="grid gap-6">
          {sessions.length === 0 ? (
            <Card className="border-2">
              <CardContent className="py-12 text-center">
                <p className="text-gray-500 text-lg">Belum ada sesi undian</p>
                <Button
                  onClick={() => navigate('/')}
                  className="mt-4 bg-gradient-to-r from-orange-600 to-pink-600"
                >
                  Mulai Undian Pertama
                </Button>
              </CardContent>
            </Card>
          ) : (
            sessions.map((session) => (
              <Card
                key={session.id}
                className="border-2 hover:shadow-lg transition-all duration-300 cursor-pointer"
                onClick={() => navigate(`/lottery/${session.id}`)}
              >
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2">
                      Undian #{session.setupNumber}
                      <Badge className={(session.type || 'paired') === 'single' ? 'bg-blue-500 hover:bg-blue-600' : 'bg-orange-500 hover:bg-orange-600'}>
                        {(session.type || 'paired') === 'single' ? 'Tunggal' : 'Berpasangan'}
                      </Badge>
                      {session.completed ? (
                        <Badge className="bg-green-500 hover:bg-green-600">
                          <CheckCircle className="w-3 h-3 mr-1" />
                          Selesai
                        </Badge>
                      ) : (
                        <Badge className="bg-orange-500 hover:bg-orange-600">
                          <Clock className="w-3 h-3 mr-1" />
                          Berlangsung
                        </Badge>
                      )}
                    </CardTitle>
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                      <Calendar className="w-4 h-4" />
                      {formatDate(session.createdAt)}
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="grid md:grid-cols-3 gap-4">
                    <div className="p-4 bg-gradient-to-r from-orange-50 to-orange-100 rounded-lg">
                      <p className="text-sm text-gray-600 mb-1">Total Nomor</p>
                      <p className="text-2xl font-bold text-orange-600">
                        {(session.type || 'paired') === 'single' ? session.setupNumber : session.setupNumber * 2}
                      </p>
                    </div>
                    <div className="p-4 bg-gradient-to-r from-pink-50 to-pink-100 rounded-lg">
                      <p className="text-sm text-gray-600 mb-1">Telah Diundi</p>
                      <p className="text-2xl font-bold text-pink-600">{session.drawnNumbers.length}</p>
                    </div>
                    <div className="p-4 bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg">
                      <p className="text-sm text-gray-600 mb-1">Tersisa</p>
                      <p className="text-2xl font-bold text-purple-600">{session.remainingNumbers.length}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Sessions;